import React from 'react';
import './Layout.scss'
function Footer() {
  return (
    <div className='w-full bg-black flex center flex-col'>
      <div className='w-[90%] lg:w-[80%] p-20'>
        <div className="grid w-full grid-cols-12 lg:gap-5">
          <div className="col-span-3 flex gap-5 items-start">
            <a href="https://www.facebook.com/hitimperial/">
              <img className='w-[18px] object-contain' src="/images/socials/facebook.png" alt="Instagram" />
            </a>
            <a href="https://www.instagram.com/hitimperial.ks/">
              <img className='w-[18px] object-contain' src="/images/socials/instagram.png" alt="Instagram" />
            </a>
          </div>
          <div className="col-span-12 lg:col-span-3 mt-10 lg:mt-0">
            <div className="flex flex-col">
              <h2 className='text-white text-base montserrat font-medium'>Vendodhja e Rezidencës</h2>
              <div className="flex items-start mt-5 w-full">
                <img src="/images/socials/location2.png" className='w-[15px] p-0 h-auto object-contain !important' alt="" />
                <p className='text-white text-xs montserrat ml-3'>
                  Rruga Nekibe Kelmendi, Prishtine, 100m nga Pallati i Drejtesise
                </p>
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-3 mt-10 lg:mt-0">
            <div className="flex flex-col">
              <h2 className='text-white text-base montserrat font-medium'>Kontakte</h2>
              <div className="flex items-start mt-5 w-full">
                <img src="/images/socials/phone-white.png" className='w-[15px] p-0 h-auto object-contain !important' alt="" />
                <p className='text-white text-xs montserrat ml-3'>
                  +383 (0) 44 100 710
                </p>
              </div>

              <div className="flex items-start mt-5 w-full">
                <img src="/images/socials/email-white.png" className='w-[15px] p-0 h-auto object-contain !important' alt="" />
                <p className='text-white text-xs montserrat ml-3'>
                  hit.imperial@hotmail.com
                </p>
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-3 flex flex-col mt-10 lg:mt-0 ">
            <h2 className='text-white text-base montserrat font-medium'>Info</h2>
            <a href="/" className="text-white montserrat text-xs mt-5">Ballina</a>
            <a href="/about" className="text-white montserrat text-xs mt-3">Rreth Nesh</a>
            <a href="/contact" className="text-white montserrat text-xs mt-3">Shprehni Interesin Tuaj</a>
          </div>
        </div>
      </div>
      <div className="w-full flex center copyr-container p-5">
        <p className='text-white text-sm montserrat'>© 2025 by Section Architecture</p>
      </div>
    </div>
  );
}

export default Footer;
